module.exports = __webpack_public_path__ + "static/media/DatBimIcon.2156beba.png";